import townService from '../../api/townService'
import { roomShapes, roofShapes, houseOperationTypes } from '../../api/constants'

// initial state
const state = {
  operationType: null,
  town: null,
  shape: null,
  roofShape: null,
  upstairsIncluded: null,
  upstairsHeight: null,
  livingFloorHeight: null,
  livingFloorNumOfRooms: null,
  livingFloorArea: null,
  basementIncluded: null,
  basementHeight: null,
  foundationHeight: null,
  numOfDoors: null,
  numOfSmallWindows: null,
  numOfLargeWindows: null,
  numOfFireplaces: null,
  description: null
}

// getters
const getters = {
  includedFloorsStr(state) {
    if(state.livingFloorHeight == null ||
      state.basementHeight == null ||
      state.basementIncluded == null ||
      state.upstairsIncluded == null ||
      state.upstairsHeight == null) {
      return null
    }
    return (state.upstairsIncluded ? 'YK + ' : '') + 'AK' + (state.basementIncluded ? ' + K' : '')
  },

  numOfWindowsStr(state) {
    if(state.numOfLargeWindows == null || state.numOfSmallWindows == null) {
      return null
    }
    return `Isoja: ${state.numOfLargeWindows} kpl|Pieniä: ${state.numOfSmallWindows} kpl`
  },

  livingFloorStr(state) {
    if(state.livingFloorArea == null || state.livingFloorNumOfRooms == null) {
      return null
    }
    return state.livingFloorArea + ' m2|' + state.livingFloorNumOfRooms + ' huone' + (state.livingFloorNumOfRooms > 1 ? 'tta' : '')
  },

  isComplete(state) {
    return state.town != null &&
      state.roofShape != null &&
      state.shape != null &&
      state.upstairsIncluded != null &&
      state.upstairsHeight != null &&
      state.livingFloorHeight != null &&
      state.livingFloorArea != null &&
      state.livingFloorNumOfRooms != null &&
      state.basementIncluded != null &&
      state.basementHeight != null &&
      state.foundationHeight != null &&
      state.numOfDoors != null &&
      state.numOfSmallWindows != null &&
      state.numOfLargeWindows != null &&
      state.numOfFireplaces != null
  },

  apiParams(state) {
    const costMultiplier = state.town.costIndex / 100.0;

    return {
      operationType: state.operationType ? state.operationType.value : null,
      townCode: state.town.code,
      roofShape: state.roofShape.value,
      floorShape: state.shape.value,
      upstairsIncluded: state.upstairsIncluded,
      upstairsHeight: state.upstairsHeight,
      livingFloorHeight: state.livingFloorHeight,
      livingFloorArea: state.livingFloorArea,
      livingFloorNumOfRooms: state.livingFloorNumOfRooms,
      basementIncluded: state.basementIncluded,
      basementHeight: state.basementHeight,
      foundationHeight: state.foundationHeight,
      numOfDoors: state.numOfDoors,
      numOfSmallWindows: state.numOfSmallWindows,
      numOfLargeWindows: state.numOfLargeWindows,
      numOfFireplaces: state.numOfFireplaces,
      description: state.description,

      costMultiplierWork: costMultiplier,
      costMultiplierMaterial: 1,
      costMultiplierSubcontracting: costMultiplier,
      costMultiplierEquipment: costMultiplier,
      costMultiplierOther: costMultiplier
    }
  }
}

// actions
const actions = {

}

// mutations
const mutations = {
  SET_OPERATION_TYPE(state, operationType) {
    state.operationType = operationType
  },
  SET_TOWN(state, town) {
    state.town = town
  },
  SET_SHAPE(state, shape) {
    state.shape = shape
  },
  SET_ROOF_SHAPE(state, roofShape) {
    state.roofShape = roofShape
  },
  SET_UPSTAIRS_INCLUDED(state, upstairsIncluded) {
    state.upstairsIncluded = upstairsIncluded
  },
  SET_UPSTAIRS_HEIGHT(state, upstairsHeight) {
    state.upstairsHeight = upstairsHeight
  },
  SET_LIVING_FLOOR_HEIGHT(state, livingFloorHeight) {
    state.livingFloorHeight = livingFloorHeight
  },
  SET_LIVING_FLOOR_NUM_OF_ROOMS(state, livingFloorNumOfRooms) {
    state.livingFloorNumOfRooms = livingFloorNumOfRooms
  },
  SET_LIVING_FLOOR_AREA(state, livingFloorArea) {
    state.livingFloorArea = livingFloorArea
  },
  SET_BASEMENT_INCLUDED(state, basementIncluded) {
    state.basementIncluded = basementIncluded
  },
  SET_BASEMENT_HEIGHT(state, basementHeight) {
    state.basementHeight = basementHeight
  },
  SET_FOUNDATION_HEIGHT(state, foundationHeight) {
    state.foundationHeight = foundationHeight
  },
  SET_NUM_OF_DOORS(state, numOfDoors) {
    state.numOfDoors = numOfDoors
  },
  SET_NUM_OF_SMALL_WINDOWS(state, numOfSmallWindows) {
    state.numOfSmallWindows = numOfSmallWindows
  },
  SET_NUM_OF_LARGE_WINDOWS(state, numOfLargeWindows) {
    state.numOfLargeWindows = numOfLargeWindows
  },
  SET_NUM_OF_FIREPLACES(state, numOfFireplaces) {
    state.numOfFireplaces = numOfFireplaces
  },
  SET_DESCRIPTION(state, description) {
    state.description = description
  },
  SET_FROM_CALCULATION(state, calculation) {
    state.operationType = houseOperationTypes.find(t => t.value == calculation.params.operationType)
    state.town = townService.getTownByCode(calculation.params.townCode)
    state.roofShape = roofShapes.find(s => s.value == calculation.params.roofShape)
    state.shape = roomShapes.find(s => s.value == calculation.params.floorShape)
    state.upstairsIncluded = calculation.params.upstairsIncluded
    state.upstairsHeight = calculation.params.upstairsHeight
    state.livingFloorHeight = calculation.params.livingFloorHeight
    state.livingFloorArea = calculation.params.livingFloorArea
    state.livingFloorNumOfRooms = calculation.params.livingFloorNumOfRooms
    state.basementIncluded = calculation.params.basementIncluded
    state.basementHeight = calculation.params.basementHeight
    state.foundationHeight = calculation.params.foundationHeight
    state.numOfDoors = calculation.params.numOfDoors
    state.numOfSmallWindows = calculation.params.numOfSmallWindows
    state.numOfLargeWindows = calculation.params.numOfLargeWindows
    state.numOfFireplaces = calculation.params.numOfFireplaces
    state.description = calculation.params.description
  },
  CLEAR(state) {
    state.operationType = null
    state.town = null
    state.shape = null
    state.roofShape = null
    state.upstairsIncluded = null
    state.upstairsHeight = null
    state.livingFloorHeight = null
    state.livingFloorNumOfRooms = null
    state.livingFloorArea = null
    state.basementIncluded = null
    state.basementHeight = null
    state.foundationHeight = null
    state.numOfDoors = null
    state.numOfSmallWindows = null
    state.numOfLargeWindows = null
    state.numOfFireplaces = null
    state.description = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/houseParams.js